import { processRequest } from '../../../services/Api';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { addListsModalActionTypes } from './Constants';
import * as addListsModalActions from './Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';

export default function* () {
	yield all([yield takeLatest(addListsModalActionTypes.GET_LIST_REQUEST, handleGetListsRequest)]);
}

export function* handleGetListsRequest({ payload }) {
	try {
		const { id, type, generalType, groupId } = payload || {};

		const isAddListType = generalType === 'addPractiseableItems';
		const isCombineType = generalType === 'combine';
		const addItemsFromRecentOrCreated = type === 'own' || type === 'recent';
		const addItemsFromFolderOrGroup = type === 'folder' || type === 'group' || type === 'book';
		let query = '';

		if (type === 'book') query = groupId ? `?group_id=${groupId}` : '';
		if (type === 'group')
			query = groupId ? `?target_group_id=${groupId}` : '?ambiguous_selection=true';

		const { data } = yield call(
			processRequest,
			(isAddListType || isCombineType) && addItemsFromRecentOrCreated
				? `practiceable_items/${type === 'own' ? 'created' : type}`
				: (isAddListType || isCombineType) && addItemsFromFolderOrGroup
				? `${type}s/${id}/practiceable_items${query}`
				: `lists?type=${type}&id=${id}`,
		);

		const finalData = data[type === 'own' ? 'created_items' : 'practiceable_items'];
		yield put(
			addListsModalActions.getListsSuccess(
				type === 'book'
					? data
					: isCombineType
					? finalData.filter((item) => item.type !== 'user_quiz')
					: finalData,
			),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(addListsModalActions.getListsError());
	}
}
